import React from "react";

type Prop = {
  ToggleHandler: () => void;
  Toggle: any;
};

function GoodsToggle(props: Prop) {
  return (
    <div className="flex items-center justify-center w-full mt-10">
      <label htmlFor="toggleB" className="flex items-center cursor-pointer">
        <div className="relative">
          <input
            type="checkbox"
            onClick={props.ToggleHandler}
            id="toggleB"
            className="sr-only"
          />
          <div className="block bg-cyan-100 w-52 h-10 rounded-full">
            <div className="flex flex-row justify-evenly space-x-3  pt-3">
              <p className=" text-xs font-semibold text-gray-900 font-Montserrat">
              Incoming
              </p>
              <p className="pl-3 text-xs font-semibold text-gray-900 font-Montserrat">
              Outgoing
              </p>
            </div>
          </div>
          <div className="dot absolute left-2 top-1 bg-white w-24 h-8 rounded-full transition shadow-md text-xs font-semibold text-blue-100 font-Montserrat text-center pt-2">
            {props.Toggle == "Incoming" ? <>Incoming</> : <>Outgoing</>}
          </div>
        </div>
      </label>
    </div>
  );
}

export default GoodsToggle;
